import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

import type { CountryFlagIconProps } from './CountryFlagIcon';
import { getFlagSize } from './utils';

export const Wrapper = styled(Box)<
  Pick<CountryFlagIconProps, 'round' | 'size'>
>`
  display: inline-grid;
  place-items: center;

  & > span {
    box-shadow: inset 0px 0px 0px 1px
      ${({ theme }) => theme.colors.primaryAlpha8};
    background-size: contain;
    background-position: 50%;
    background-repeat: no-repeat;
    position: relative;
    display: inline-block;

    ${({ round }) =>
      round &&
      css`
        border-radius: 50%;
      `}
  }

  ${({ size }) => getFlagSize(size)}
`;
